import { fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { createApi } from "@reduxjs/toolkit/query/react";
import { configApi } from "@shared/lib/configApi";
import {
    HistorySmallReportData,
    HistorySmallReportResponse,
    ReportProduct,
    ReportProductsResponse
} from "./types";

export const publicHistoryApi = createApi({
    reducerPath: "publicHistoryApi",
    tagTypes: ["SMALL_REPORT_TAG", "REPORT_PRODUCTS"],
    baseQuery: fetchBaseQuery({
        prepareHeaders: (headers) => {
            return headers;
        }
    }),
    endpoints: (builder) => ({
        getSmallReport: builder.query<HistorySmallReportData, { code: string }>({
            query: ({ code }) => ({
                url: `${configApi.API_URL}/v1/reports/small`,
                method: "POST",
                body: { code }
            }),
            transformResponse: (response: HistorySmallReportResponse) => response.data,
            providesTags: ["SMALL_REPORT_TAG"]
        }),
        getReportProducts: builder.query<ReportProduct[], void>({
            query: () => `${configApi.API_URL}/v1/reports/products`,
            transformResponse: (response: ReportProductsResponse) => response.data,
            providesTags: ["REPORT_PRODUCTS"]
        })
    })
});

export const { useGetSmallReportQuery } = publicHistoryApi;